document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper !== "undefined") {
    document.querySelectorAll('.product-desc-swiper').forEach((swiperEl, index) => {
      const swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 1.2,
        spaceBetween: 15,
        loop: false,
        breakpoints: {
          768: { slidesPerView: 2.5, spaceBetween: 24 },
          1024: { slidesPerView: 3.5, spaceBetween: 32 }
        }
      });

      // Find the parent block that contains arrows
      const container = swiperEl.closest('.product-desc-slider');
      if (container) {
        const prevBtn = container.querySelector('.arrow-button:first-child');
        const nextBtn = container.querySelector('.arrow-button:last-child');

        if (prevBtn && nextBtn) {
          prevBtn.addEventListener('click', () => swiperInstance.slidePrev());
          nextBtn.addEventListener('click', () => swiperInstance.slideNext());
        }
      }
    });
  }
});
